<template>
  <div>
    <div class="top">
      <TopContent />
    </div>
    <div class="product_bg"></div>
    <div class="product_con">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span @click="() => { this.$router.go(-1) }" class="goback">返回</span></el-breadcrumb-item>
        <el-breadcrumb-item>启秘大数据健康管理平台</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="con_tit fontsize2">启秘大数据健康管理平台</div>
      <p class="fontsize1">
        <span class="con_text">简介：</span><br>
        平台采用新型传感器、物联网、通信等技术相结合，在整合医院所有体检仪器设备、软件系统集成互联的基础上通过对个人、群体的健康数据进行采集和分析，实现个体健康与健康评估分析、健康监测、健康指导干预的数据化、自动化、消息化，从而对群体或者个人提供警示、建议、咨询等检后服务模式的系统平台。
        用户通过对接体检系统和可穿戴设备采集基础数据（包括：血压、血糖、心率、身高、体重、体脂等）上传，可通过手机 APP
        实时查看到监测的数据。除此之外平台通过对采集的基础数据进行分析处理，定期生成报告给到合作的健康管理机构，由健康管理机构对个人实时健康管理干预和健康指导。<br><br>
        <span class="con_text">产品线路图：</span>
        <br>
      </p>
      <div class="con_img"><img src="../../assets/img/Product2s.png" /></div>
      <p class="fontsize1">
        <span class="con_text">特点 / 技术指标：</span><br>
        ·通过移动手机终端查阅个人历年的体检报告。<br>
        ·可同步指定品牌的血压计、血糖仪的测量数据，形成历史记录曲线后实时查阅。<br>
        ·查询在合作医院的就诊记录、体检信息（包括化验数据、医学影像数据）。<br>
        ·可根据就诊信息按时提醒复诊、吃药。<br>
        ·据穿戴设备采集的数据，如出现异常数据即可向个人发出提示信息，同时也可在线向合作医院坐诊医生根据自身身体情况提出疑问，<br> &nbsp;&nbsp;&nbsp;&nbsp;由坐诊医生进行在线解答。<br><br>

        <span class="con_text">应用案例：</span><br>

        2015
        年云南启秘科技有限公司通过和云大校医院两年的亲密合作建成了云大校医院大数据健康管理平台。平台建成电子健康档案管理、体检数据分析评估，健康跟踪干预等模块。为校医院健康体检档案的采集、存储、传递、共享和实施全面的健康管理服务提供了技术支持。实现了节约医疗资源、降低医疗开支并逐步推动校医院工作重点由治疗疾病为主向预防保健为主转变。
        现在，云南大学教职工的体检单干就装在自己的手机上随时随地可以查询自己的健康状况。
      </p>
    </div>
    <div class="bottom">
      <BottomContent />
    </div>
  </div>
</template>
<script>
import TopContent from "@/components/Top/index.vue";
import BottomContent from "@/components/Bottom/index.vue";
export default {
  components: { TopContent, BottomContent },
  data () {
    return {

    }
  },
  mounted () {
    if (document && document.body) {
      document.body.style.margin = '0px';
      this.originalBodyMargin = document.body.style.margin;
    }
  },
  beforeDestroy () {
    if (document && document.body) {
      document.body.style.margin = this.originalBodyMargin || '';
    }
  }
}
</script>
<style lang="scss" src="../../assets/css/PC.scss" scoped></style>
<style lang="scss" scoped>
.goback:hover {
  cursor: pointer;
  color: #409EFF;
}

.bottom {
  height: 70px;
}

.product_bg {
  background-image: url("../../assets/img/Product_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 70vh;
}

.fontsize1 {
  font-size: 19px;
}

.fontsize2 {
  font-size: 24px;
}

.product_con {
  width: 70%;
  margin: 0px auto 50px auto;
  padding: 20px;

  .con_tit {
    font-weight: 600;
    text-align: center;
    margin: 20px 0px;
  }

  .con_text {
    font-weight: 600;
  }

  .con_img {
    display: flex;
    justify-content: center;

    img {
      max-width: 70%;
      height: 100%;
    }

  }
}

@media (max-width: 1439px) and (min-width: 10px) {
  .product_bg {
    height: 30vh;
  }

  .fontsize1 {
    font-size: 15px;
  }

  .product_con {
    margin: auto;
    width: 90%;

    .con_img {
      img {
        max-width: 90%;
      }
    }
  }
}
</style>